// src/components/BerkeleyTopic_To_Classes.jsx
export const BerkeleyTOPIC_TO_CLASSES = {
  science: [
    "ANTHRO 2AC - Archaeology",
    "LINGUIS R1B - Linguistics Science",
    "ASTRON 7A",
    "ASTRON C10",
    "BIOLOGY 1A",
    "BIOLOGY 1B",
    "CHEM 1A",
    "CHEM 3A",
    "CHEM 3B",
    "CHEM 4A",
    "CHEM C130",
    "CHEM 135",
    "EPS 7",
    "EPS C20",
    "EPS 50",
    "EPS 80",
    "EPS 82",
    "EPS 100A",
    "EPS 102",
    "EPS 109",
    "EPS 117",
    "GEOG 40",
    "INTEGBI 11",
    "INTEGBI 118",
    "INTEGBI 131",
    "INTEGBI C158L",
    "INTEGBI C160",
    "MCELLBI 32",
    "MCELLBI 55",
    "MCELLBI 102",
    "MCELLBI C100A",
    "NEU C62",
    "PHYSICS 5A",
    "PHYSICS 5B",
    "PHYSICS 5C",
    "PHYSICS 7A",
    "PHYSICS 7B",
    "PHYSICS 7C",
    "PHYSICS 8A",
    "PHYSICS 8B",
    "PHYSICS 10",
    "PHYSICS 105",
    "PHYSICS 110A",
    "PHYSICS 111A",
    "PHYSICS 137A",
    "PHYSICS 137B",
    "XMCELLB 32",
    "XINTEGB 31",
    "XINTEGB 33"
  ],
  business: [

    "HISTORY 133B - Wall Street / Main Street",
   
    "PUBPOL 117AC - Race, Ethnicity, and Public Policy",
    "ECON 1",
    "ECON 2",
    "ECON C3",
    "ECON 100A",
    "ECON 100B",
    "ECON 101A",
    "ECON 101B",
    "ECON 151",
    "ECON 162",
    "ECON 172",
    "ECON C171",
    "ECON C181",
    "ENVECON C1",
    "ENVECON C176",
    "ENVECON C181",
    "POLECON 100",
    "POLECON 101",
    "POLECON 107",
    "PUBPOL 101",
    "UGBA 101A",
    "UGBA 101B",
    "UGBA 107",
    "UGBA 152",
    "UGBA 160",
    "UGBA 178",
    "GLOBAL 100P",
    "GPP 115"
  ],
  social: [
    "AFRICAM 27AC - African American Literature",
    "AFRICAM R1B - African American Studies",
    "AMERSTD 101AC - American Culture and Studies",
    "ANTHRO 3AC - American Anthropology",
    "ASAMST 20AC - Asian American Studies",
    "ASAMST 128AC - Muslims in America",
    "COLWRIT 25AC - Diversity and Access in U.S. Public Education",
    "CYPLAN 118AC - The Urban Community",
    "GWS 50AC - Gender in American Culture",
    "GWS 100AC - Women in American Culture",
    "GEOG 50AC - California",
    "LINGUIS 55AC - The American Languages",
    "SOCIOL 3AC - Principles of Sociology: American Cultures",
    "SOCIOL 111AC - Sociology of the Family",
    "SOCIOL 113AC - Sociology of Education",
    "SOCWEL 150AC - Race, Ethnic Relations, and Social Welfare in the United States",
    "XASAMST 20AC - Asian American Communities and Race Relations",
    "XETHSTD 21AC - A Comparative Survey of Racial and Ethnic Groups in the U.S",
    "ANTHRO R5B - Anthropology",
    "XSOCIOL 3AC - Principles of Sociology: American Cultures",
    "AFRICAM 5A",
    "AFRICAM 101",
    "AFRICAM C133A",
    "AFRICAM 144",
    "AFRICAM 164",
    "AMERSTD 10",
    "AMERSTD 101AC",
    "ANTHRO 2AC",
    "ANTHRO 3AC",
    "ANTHRO 106",
    "ANTHRO 111",
    "ANTHRO C119A",
    "ANTHRO 156A",
    "ANTHRO 181",
    "ANTHRO 183",
    "ANTHRO 189",
    "ARCH 130",
    "ASAMST 20AC",
    "ASAMST 20C",
    "ASAMST 122",
    "ASAMST 128AC",
    "ASAMST 138",
    "ASAMST 141",
    "ASAMST 173",
    "ASAMST 175",
    "CHICANO 50",
    "CHICANO 135B",
    "CHICANO 159",
    "CHICANO 161",
    "CYPLAN 110",
    "CYPLAN 113A",
    "CYPLAN 115",
    "CYPLAN 118AC",
    "CYPLAN 119",
    "DATA 6",
    "DEMOG 110",
    "DEMOG C126",
    "DUTCH 179",
    "EALANG 118",
    "ENVDES 1",
    "ENVDES 102",
    "ENVECON C1",
    "ESPM 50AC",
    "ESPM 163AC",
    "FRENCH 43A",
    "GEOG 10AC",
    "GEOG C32",
    "GEOG 50AC",
    "GEOG C55",
    "GEOG 138",
    "GEOG 181",
    "GLOBAL 10B",
    "GLOBAL 45",
    "GLOBAL C10A",
    "GLOBAL 121",
    "GLOBAL 132",
    "GLOBAL 150Q",
    "GLOBAL 173",
    "GPP 105",
    "GPP 115",
    "GWS 10",
    "GWS 50AC",
    "GWS 100AC",
    "GWS 102",
    "GWS 125",
    "GWS 130AC",
    "GWS 133AC",
    "GWS 142",
    "IAS C176",
    "ISF 100A",
    "ISF 100B",
    "ISF 100C",
    "ISF 100F",
    "ISF C100G",
    "ITALIAN 160",
    "LGBT 20AC",
    "LINGUIS 55AC",
    "MEDIAST 10",
    "MEDIAST 180",
    "MELC 124",
    "MILAFF 145A",
    "NATAMST 20A",
    "NATAMST 71",
    "NATAMST 179",
    "PUBPOL 101",
    "PUBPOL 117AC",
    "SCANDIN 75",
    "SOCIOL 1",
    "SOCIOL 3AC",
    "SOCIOL 5",
    "SOCIOL 7",
    "SOCIOL 101",
    "SOCIOL 102",
    "SOCIOL 110",
    "SOCIOL 111AC",
    "SOCIOL 113AC",
    "SOCIOL 120",
    "SOCIOL 121",
    "SOCIOL 124",
    "SOCIOL C126",
    "SOCIOL 127",
    "SOCIOL 130",
    "SOCIOL 131AC",
    "SOCIOL 135",
    "SOCIOL 137AC",
    "SOCIOL 139",
    "SOCIOL 160",
    "SOCIOL 163",
    "SOCIOL 165",
    "SOCIOL 166",
    "SOCIOL 167",
    "SOCIOL 169",
    "SOCIOL 179",
    "SOCIOL 180C",
    "SOCIOL 190",
    "SOCWEL 150AC",
    "UGIS 110",
    "XANTHRO 1",
    "XESPM 50AC",
    "XETHSTD 21AC",
    "XGEOG 4",
    "XGLOBAL 10B",
    "XSOCIOL 3AC"
  ],
  health: [
   
    "ASAMST 143AC - Asian American Health",
    "GWS 130AC - Gender, Race, Nation, and Health",
  
     "BIOLOGY 1A",
    "BIOLOGY 1B",
    "INTEGBI 118",
    "INTEGBI 131",
    "MCELLBI 32",
    "MCELLBI 55",
    "MCELLBI 102",
    "MCELLBI C100A",
    "NEU C62",
    "NUSCTX 10",
    "PBHLTH 101",
    "PBHLTH 116",
    "PBHLTH 150B",
    "PBHLTH 162A",
    "PBHLTH 181",
    "PSYCH 114",
    "PSYCH 131",
    "PSYCH 150",
    "SOCWEL 150AC",
    "XESPM 15",
    "XMCELLB 32"
  ],
  education: [
    "EDUC 131AC - A Focus on Equity and Urban Schools",
    "EDUC 140AC - Educational Perspectives on Literacy and Learning in a Global World",
    "EDUC W140A - Educational Perspectives on Literacy and Learning in a Global World",
    "EDUC C181 - What is the Role of Race in Urban Schools?",
    "EDUC W190A - Critical Studies in Education",
    "EDUC 282 - Introduction to Disciplined Inquiry",
    "COLWRIT 25AC - Diversity and Access in U.S. Public Education",
    "SOCIOL 113AC - Sociology of Education",
    "COLWRIT 25AC",
    "EDUC 114A",
    "EDUC 130",
    "EDUC 131AC",
    "EDUC 140AC",
    "EDUC W140A",
    "EDUC C181",
    "UGIS 110",
    "GPP 105",
    "AMERSTD 101AC"
  ],
  engineering: [
    "CYPLAN 118AC - The Urban Community",
    "ESPM 50AC - Introduction to Culture and Natural Resource Management",
    "ESPM 163AC - Environmental Justice: Race, Class, Equity, and the Environment",
    "GEOG 10AC - Worldings: Regions, Peoples and States",
    "GEOG 50AC - California",
    "HISTART R1B - Reading and Writing about Visual Experience",
    "ENGIN 125",
    "BIOENG 10",
    "BIOENG 100",
    "COMPSCI 61C",
    "COMPSCI 188",
    "PHYSICS 111A",
    "ARCH 170A",
    "LDARCH 12",
    "LDARCH C171",
    "LDARCH C188",
    "ENVDES 1",
    "ENVDES 102",
    "ENERES C100"
  ],
  math: [
    "PHILOS R1B - Reading and Composition through Philosophy",
     "PHILOS 12A",
    "ECON 100A",
    "ECON 100B",
    "ECON 101A",
    "ECON 101B",
    "ECON 172",
    "ECON C110",
    "DEMOG 110",
    "EPS 109",
    "PHYSICS 105",
    "PHYSICS 110A",
    "PHYSICS 137A",
    "DATA 6",
    "DATA C104",
    "LINGUIS R1B - Linguistics Science",
    "SOCIOL R1B - Sociological Reading & Composition",
    "EDUC 282 - Introduction to Disciplined Inquiry",
    "AHMA R1B - Ancient History and Mediterranean Archaeology",
    "GEOG 10AC - Worldings: Regions, Peoples and States"
  ],
  language: [
    "GERMAN R5A - German Literature",
    "FRENCH R1B - Narrating Childhood in 20th Century France",
    "ITALIAN R5A - Italian Literature",
    "ITALIAN R5B - The Art of Protest",
    "SPANISH R1A - Reading and Composition Through Readings from the Spanish-Speaking World",
    "SCANDIN R5A - Scandinavian Literature and Culture",
    "SCANDIN R5B - Scandinavian Literature",
    "SLAVIC R5A - Literature of Fantastic Transformation",
    "SLAVIC R5B - Slavic Literature",
    "CELTIC R1B - Celtic Writers",
    "EALANG R1B - East Asia",
    "SASIAN R5A - Great Books of India",
    "SASIAN R5B - India in the Writer's Eye",
    "SEASIAN R5A - Self, Representation, and Nation",
    "LINGUIS 55AC - The American Languages",
    "AFRICAM C133A - African American Language and Studies",
    "DUTCH 171AC - Dutch Culture",
    "NATAMST R1A - Native American Studies Reading and Composition",
    "CHICANO R1A - Introduction to Chicano Literature in English",
    "MELC R1A - Middle Eastern Culture",
    "ARABIC 100A",
    "CHINESE 7A",
    "CHINESE 100A",
    "CHINESE 100XA",
    "CHINESE 102",
    "CHINESE 110A",
    "CHINESE 111",
    "CHINESE 157",
    "CHINESE 186",
    "EALANG 118",
    "EALANG 119",
    "EALANG C134",
    "FRENCH 80",
    "FRENCH 102",
    "FRENCH 112A",
    "FRENCH 119A",
    "FRENCH 121A",
    "FRENCH 141",
    "FRENCH 161A",
    "FRENCH 185",
    "GERMAN 39B",
    "GERMAN 39Q",
    "GERMAN 100",
    "GERMAN 101",
    "GERMAN 102D",
    "GERMAN 133",
    "GERMAN 185",
    "GREEK 100",
    "GREEK 102",
    "HEBREW 100A",
    "HINDI 101A",
    "ITALIAN 40",
    "ITALIAN 101",
    "ITALIAN 102",
    "ITALIAN 130A",
    "ITALIAN 160",
    "JAPAN 7A",
    "JAPAN 100A",
    "JAPAN 120",
    "JAPAN 155",
    "JEWISH 100",
    "JEWISH 120A",
    "JEWISH 121B",
    "JEWISH 123A",
    "KHMER 101A",
    "KOREAN 7A",
    "KOREAN 100A",
    "KOREAN 101",
    "KOREAN 105",
    "KOREAN 111",
    "KOREAN 155",
    "KOREAN 186",
    "LATIN 100",
    "LATIN 122",
    "LINGUIS 55AC",
    "LINGUIS 100",
    "LINGUIS 110",
    "LINGUIS 115",
    "LINGUIS C137",
    "LINGUIS C142",
    "LINGUIS C160",
    "LINGUIS 170",
    "MDGRK 1A",
    "MELC 10",
    "MELC 134",
    "MELC 135",
    "MELC 146",
    "MONGOLN C117",
    "PERSIAN 100A",
    "PERSIAN 104A",
    "PORTUG 102",
    "PORTUG 104",
    "SASIAN 131",
    "SEASIAN 150",
    "SLAVIC 45",
    "SLAVIC 100",
    "SLAVIC C134N",
    "SLAVIC C137",
    "SLAVIC 138",
    "SLAVIC 170",
    "SLAVIC 171",
    "SLAVIC 188",
    "SPANISH 25",
    "SPANISH 100",
    "SPANISH 102A",
    "SPANISH 104A",
    "SPANISH 107B",
    "SPANISH 135",
    "SPANISH 161",
    "SPANISH 179",
    "VIETNMS 101A",
    "CELTIC 70",
    "CELTIC 139",
    "CELTIC 168"
  ],
  environment: [
    "ESPM 50AC - Introduction to Culture and Natural Resource Management",
    "ESPM 163AC - Environmental Justice: Race, Class, Equity, and the Environment",
    "SOCIOL 137AC - Environmental Justice: Race, Class, Equity, and the Environment",
    "GEOG 10AC - Worldings: Regions, Peoples and States",
    "GEOG 50AC - California",
    "GWS 133AC - Women, Men, and Other Animals: Human Animality in American Cultures",
    "XESPM 50AC - Introduction to Culture and Natural Resource Management",
    "ENERES C100",
    "ENVECON C1",
    "ENVECON C176",
    "ENVECON C181",
    "ESPM 6",
    "ESPM 15",
    "ESPM 42",
    "ESPM 50AC",
    "ESPM C107",
    "ESPM 108A",
    "ESPM 116B",
    "ESPM C162A",
    "ESPM 163AC",
    "GEOG 10AC",
    "GEOG 40",
    "GEOG 138",
    "GEOG 181",
    "LDARCH 12",
    "LDARCH C171",
    "LDARCH C188",
    "ENVDES 1",
    "ENVDES 102",
    "CYPLAN 115",
    "CYPLAN 119",
    "EPS 80",
    "EPS 82",
    "IAS C176",
    "XESPM 15",
    "XGEOG 4"
  ],
  communication: [
    "COLWRIT R1A - Accelerated Reading and Composition 6 Units",
    "COLWRIT R4A",
    "COMLIT R1A - English Composition in Connection",
    "ENGLISH R1A - College Writing",
    "FILM R1A - The Craft of Writing Film Focus",
    "RHETOR R1A - The Craft of Writing",
    "COLWRIT R4B - 2nd Half Reading and Composition",
    "ENGLISH R1B - Reading and Composition",
    "FILM R1B - Film Comprehension",
    "RHETOR R1B - The Craft of Writing",
    "XCOLWRI R1A - College Writing R1A",
    "XCOMLIT R1A - Comparative Literature",
    "RHETOR 10",
    "RHETOR 20",
    "RHETOR 103A",
    "RHETOR 117",
    "RHETOR 129AC",
    "RHETOR 137",
    "RHETOR 156",
    "MEDIAST 10",
    "MEDIAST 180",
    "FILM 20",
    "FILM 145",
    "FILM 170",
    "FILM 180",
    "FILM 184",
    "FILM 185",
    "COMLIT 20C",
    "COMLIT 100",
    "COMLIT 154",
    "COMLIT 155",
    "COMLIT 171",
    "COLWRIT 25AC",
    "ENGLISH 43A",
    "ENGLISH 45A",
    "ENGLISH 45B",
    "ENGLISH 45C",
    "ENGLISH 90",
    "ENGLISH 100",
    "ENGLISH 104",
    "ENGLISH 112",
    "ENGLISH 115A",
    "ENGLISH 117S",
    "ENGLISH 121",
    "ENGLISH 130B",
    "ENGLISH 131",
    "ENGLISH 138",
    "ENGLISH 141",
    "ENGLISH 143A",
    "ENGLISH 143B",
    "ENGLISH 143C",
    "ENGLISH 143N",
    "ENGLISH 161",
    "ENGLISH 174",
    "ENGLISH 176",
    "MUSIC 48" ,
    "XENGLIS R1A - English",
    "XENGLIS R1B - Societal Reading and Composition",
    "THEATER R1B - Performance: Writing and Research",
    "COMLIT R1B - English Composition in Connection with the Reading of World Literature",
    "COMLIT R3B - English Composition in Connection with Reading of World and Hispanic Literature"
  ],
  law: [
    "LEGALST R1B - Reading and Composition in Connection with the Law as a Social Institution",
    "LEGALST 162AC - Restorative Justice",
    "PUBPOL 117AC - Race, Ethnicity, and Public Policy",
    "SOCIOL 131AC - Race and Ethnic Relations: U.S. American Cultures",
    "XETHSTD 21AC - A Comparative Survey of Racial and Ethnic Groups in the U.S",
    "LEGALST 100",
    "LEGALST 102",
    "LEGALST 103",
    "LEGALST 119",
    "LEGALST 138",
    "LEGALST 141",
    "LEGALST 145",
    "LEGALST 147",
    "LEGALST 157",
    "LEGALST 160",
    "LEGALST 162AC",
    "LEGALST 170",
    "LEGALST 177",
    "LEGALST 184",
    "GWS 133AC",
    "PBHLTH 150B",
    "PUBPOL 101",
    "RHETOR 117",
     
  ],
  history: [
    "AHMA R1B - Ancient History and Mediterranean Archaeology",
    "HISTORY R1B - Reading and Composition courses in History",
    "HISTORY 7A - Introduction to the History of the United States: The United States from Settlement to Civil War",
    "HISTORY 124B - The Recent United States: The United States from World War II",
    "XHISTOR 7B - The United States from Civil War to Present",
    "HISTORY 125A - African American History and Race Relations: 1450-1860",
    "HISTORY 133B - Wall Street / Main Street",
    "AGRS 10A",
    "AGRS 17A",
    "AGRS R44",
    "AGRS 130M",
    "AMERSTD 10",
    "AMERSTD 101AC",
    "AMERSTD C152",
    "ASAMST 173",
    "ASAMST 175",
    "CELTIC 139",
    "EALANG C134",
    "HISTART 10",
    "HISTART 30",
    "HISTART 89",
    "HISTART 100",
    "HISTART C121A",
    "HISTART 131A",
    "HISTART 175",
    "HISTART 190F",
    "HISTART 190M",
    "HISTORY 4A",
    "HISTORY 5",
    "HISTORY 7A",
    "HISTORY 8A",
    "HISTORY 10",
    "HISTORY 12",
    "HISTORY 14",
    "HISTORY 30",
    "HISTORY 100AC",
    "HISTORY 100B",
    "HISTORY 100F",
    "HISTORY 100M",
    "HISTORY 103B",
    "HISTORY 103D",
    "HISTORY 103U",
    "HISTORY 104",
    "HISTORY 108",
    "HISTORY 116G",
    "HISTORY 124B",
    "HISTORY 125A",
    "HISTORY 133B",
    "HISTORY 142",
    "HISTORY C159A",
    "HISTORY 160",
    "HISTORY 166B",
    "HISTORY 171C",
    "HISTORY 182CT",
    "HISTORY C182C",
    "HISTORY 183B",
    "HISTORY 192A",
    "HUM 10",
    "JEWISH 120A",
    "MELC 10",
    "MELC C121",
    "MELC 135",
    "NATAMST C152",
    "SCANDIN 100A",
    "SCANDIN 101A",
    "SCANDIN 106",
    "SCANDIN 165",
    "SEASIAN 150",
    "SLAVIC 100",
    "SLAVIC 138",
    "SLAVIC 170",
    "SLAVIC 171",
    "SLAVIC 188",
    "AMERSTD 101AC - American Culture and Studies",
    "ITALIAN 70AC - The Recent United States: The United States from World War II",
    "MELC 117AC - The Origins of Racism in the West",
    "GEOG 50AC - California",
    "GEOG 10AC - Worldings: Regions, Peoples and States"
  ],
  philosophy: [
    "PHILOS R1B - Reading and Composition through Philosophy",
    "RHETOR 129AC - Individualism and American Autobiography",
    "ETHSTD 22AC - An Introduction to Abolition Pedagogy and Practice",
    "MELC 117AC - The Origins of Racism in the West",
    "ITALIAN R5B - The Art of Protest",
    "BUDDSTD C50",
    "BUDDSTD C115",
    "BUDDSTD C117",
    "CHINESE 186",
    "HUM 10",
    "JAPAN C115",
    "LINGUIS C142",
    "PHILOS 2",
    "PHILOS 3",
    "PHILOS 12A",
    "PHILOS 18",
    "PHILOS 25A",
    "PHILOS 100",
    "PHILOS 115",
    "PHILOS 116",
    "PHILOS 128",
    "PHILOS 132",
    "PHILOS 133",
    "PHILOS 146",
    "PHILOS 156A",
    "PHILOS 170",
    "PHILOS 176",
    "PHILOS 181"
  ],
  computer: [
    "RHETOR 129AC - Individualism and American Autobiography",
    "COLWRIT R1A - Accelerated Reading and Composition 6 Units",
    "FILM R1B - Film Comprehension",
    "ENGLISH R1A - College Writing",
    "XCOMLIT R1A - Comparative Literature",
    "LINGUIS 55AC - The American Languages",
    "GEOG 10AC - Worldings: Regions, Peoples and States",
    "COMPSCI 61C",
    "COMPSCI 188",
    "DATA 6",
    "DATA C104",
    "EPS 109",
    "GEOG C188",
    "COGSCI C127",
    "PSYCH C127"
  ],
  psychology: [
    "SOCIOL 3AC - Principles of Sociology: American Cultures",
    "SOCIOL 111AC - Sociology of the Family",
    "SOCIOL 131AC - Race and Ethnic Relations: U.S. American Cultures",
    "PBHLTH 155E - Seeing People: Understanding Homelessness' Roots, Stigmas & Solutions - A Berkeley Changemaker Course",
    "RHETOR 129AC - Individualism and American Autobiography",
    "AFRICAM 27AC - African American Literature",
    "ASAMST R2A - Asian American Literature",
    "GWS 50AC - Gender in American Culture",
    "COGSCI 1",
    "COGSCI C100",
    "COGSCI C140",
    "COGSCI C142",
    "COGSCI 180",
    "NEU C62",
    "PSYCH 1",
    "PSYCH 101",
    "PSYCH 114",
    "PSYCH C120",
    "PSYCH 130",
    "PSYCH 131",
    "PSYCH 140",
    "PSYCH 150",
    "PSYCH 160",
    "PSYCH C162"
  ],
  politics: [
    "POLSCI 1 - The Politics of Immigration",
    "XPOLSCI 1 - Introduction to American Politics",
    "PUBPOL 117AC - Race, Ethnicity, and Public Policy",
    "LEGALST 162AC - Restorative Justice",
    "LGBT 20AC - Sexual Politics and Queer Organizing in the US",
    "CYPLAN 118AC - The Urban Community",
    "POLSCI 1",
    "POLSCI 3",
    "POLSCI 5",
    "POLSCI 109M",
    "POLSCI 112B",
    "POLSCI 124M",
    "POLSCI 132C",
    "POLSCI C135",
    "POLSCI 148A",
    "POLSCI 149B",
    "POLSCI 149E",
    "POLSCI 149W",
    "POLSCI 161",
    "POLSCI 171",
    "POLSCI 181",
    "POLECON 100",
    "POLECON 101",
    "PUBPOL 101",
    "PUBPOL 117AC",
    "GLOBAL 173",
    "XPHILOS 2",
    "XPOLSCI 1",
    "XPOLSCI 2",
    "ASAMST 128AC - Muslims in America",
    "SOCIOL 131AC - Race and Ethnic Relations: U.S. American Cultures",
    "GEOG 10AC - Worldings: Regions, Peoples and States",
    "AMERSTD 101AC - American Culture and Studies",
    "MELC 158 - Middle East: Post-Colonialism, Migration, and Diaspora"
  ],
  Art: [
    "FILM R1A - The Craft of Writing Film Focus",
    "FILM R1B - Film Comprehension",
    "HISTART R1B - Reading and Writing about Visual Experience",
    "THEATER R1A - Reading and Composition",
    "THEATER R1B - Performance: Writing and Research",
    "THEATER 52AC - Dance in American Cultures",
    "XTHEATR 52AC - Dance in American Cultures",
    "GERMAN R5A - German Literature",
    "SCANDIN R5A - Scandinavian Literature and Culture",
    "ITALIAN R5B - The Art of Protest",
    "ARCH 170A",
    "ART 8",
    "ART 12",
    "ART 13",
    "ART 14",
    "ART 15",
    "ART 21",
    "ART 26",
    "ART 102",
    "ART 118",
    "ART 119",
    "ART 132",
    "ART 133",
    "ART 160",
    "ART 172",
    "ART 173",
    "ART 180",
    "ENVDES 1",
    "ENVDES 102",
    "HISTART 10",
    "HISTART 30",
    "HISTART 100",
    "HISTART C121A",
    "HISTART 131A",
    "HISTART 175",
    "HISTART 190F",
    "HISTART 190M",
    "NATAMST C152",
    "THEATER 10",
    "THEATER 26",
    "THEATER 52AC",
    "THEATER 60",
    "THEATER 109",
    "THEATER 110A",
    "THEATER 111",
    "THEATER 112",
    "THEATER 114",
    "THEATER 119",
    "THEATER 121",
    "THEATER 144",
    "THEATER 146A",
    "THEATER 162",
    "THEATER 173",
    "THEATER 174",
    "THEATER 175A",
    "XTHEATR 52AC",
    "SLAVIC R5A - Literature of Fantastic Transformation"
  ],
  music: [
    "MUSIC 26AC - Music in American Culture",
    "MUSIC R1B - Music Reading and Writing",
    "MUSIC 25",
    "MUSIC 26AC",
    "MUSIC 30",
    "MUSIC 48",
    "MUSIC 70",
    "MUSIC 80",
    "MUSIC 108",
    "MUSIC 128",
    "MUSIC 139",
    "MUSIC 154A",
    "MUSIC 155",
    "MUSIC 156",
    "MUSIC 157A",
    "MUSIC 159",
    "MUSIC 170",
    "MUSIC 170A",
    "XMUSIC 26AC",
    "XMUSIC 27",
    "XMUSIC 26AC - Music in American Culture",
    "THEATER 52AC - Dance in American Cultures"
  ]
};


